import { ANNOUNCEMENTS_DISMISSED } from '../../constants/cookies';
import storage from '../../storage';
import { dateMoment } from '../../utils';

export function updateAnnouncements(state, action) {
  const data =
    action.data && action.data.data && action.data.data.data
      ? action.data.data.data
      : [];

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
    };
  }

  // data present
  const dataFiltered = [...data];

  const dismissedAnnouncements = storage.getItem(ANNOUNCEMENTS_DISMISSED) || [];

  for (let index = 0; index < dataFiltered.length; index++) {
    const element = dataFiltered[index];

    const target = dismissedAnnouncements.find(
      (item) => item._id === element._id
    );

    if (!target) {
      continue;
    }

    dataFiltered[index] = {
      ...target,
      ...dataFiltered[index],
    };
  }

  action.data.data.data = dataFiltered;

  return action.data.data;
}

export function updateDismissAnnouncements(state, id) {
  const data = state.data && state.data.data ? state.data.data : [];
  const nowMoment = dateMoment();

  if (!data.length) {
    return {
      data: {
        ...state.data,
        data: [],
      },
    };
  }

  // data present
  const dataFiltered = [...data];

  const targetDataIndex = dataFiltered.findIndex((item) => item._id === id);

  if (targetDataIndex < 0) {
    return {
      data: {
        ...state.data,
        data: [],
      },
    };
  }

  dataFiltered[targetDataIndex].dismissedAt = Date.now();

  const dataFilteredForStorage = [];

  for (let index = 0; index < dataFiltered.length; index++) {
    const element = dataFiltered[index];

    if (!element.dismissedAt) {
      continue;
    }

    // filter out expired
    if (element.expiresAt) {
      const expiresAtMoment = dateMoment(element.expiresAt);

      if (expiresAtMoment.isBefore(nowMoment)) {
        continue;
      }
    }

    dataFilteredForStorage.push({
      _id: element._id,
      dismissedAt: element.dismissedAt,
    });
  }

  storage.setItems({
    [ANNOUNCEMENTS_DISMISSED]: dataFilteredForStorage,
  });

  state.data.data = dataFiltered;

  return state.data;
}

export function updateAnnouncementsSocketData(state, action) {
  const newData = action.data || [];

  // data present
  const dataFiltered = [...newData];

  const dismissedAnnouncements = storage.getItem(ANNOUNCEMENTS_DISMISSED) || [];

  for (let index = 0; index < dataFiltered.length; index++) {
    const element = dataFiltered[index];

    const target = dismissedAnnouncements.find(
      (item) => item._id === element._id
    );

    if (!target) {
      continue;
    }

    dataFiltered[index] = {
      ...target,
      ...dataFiltered[index],
    };
  }

  if (!state.data) {
    state.data = {};
  }

  state.data.data = dataFiltered;

  return state.data;
}
